import { search } from "core-js/fn/symbol";

export default {
    header: {
        logout: '退出登录',
        changePassword: '修改密码'
    },
    tabs: {
        inquireGoods: '查货',
        purchasingModule: '采购模块',
        changePassword: '修改密码'
    },
    search: {
        yes: '是',
        no: '否'
    },
    goods: {
        codeSearch: '产品编号',
        codeSearchPlaceholder: '请输入',
        isStock: '库存 > 0',
        tatting: '梭织',
        knit: '针织',
        alias: '别称',
        bulk: '大货库存',
        sample: '样品库存',
        meter: '米',
        composition: '成分',
        width: '门幅',
        weight: '克重',
    },
    login: {
        title: '天时供应链管理系统',
        login: '登录',
        account: '账号手机号',
        password: '密码'
    },
    changePassword: {
        currentPassword: '当前密码',
        currentPasswordPlaceholder: '密码长度不少于6位',
        newPassword: '新密码',
        newPasswordPlaceholder: '新密码和当前密码不能相同',
        confirmPassword: '确认密码',
        confirmPasswordPlaceholder: '确认密码和新密码保持一致',
        changePassword: '修改密码',
        submit: '修改密码',
        close: '关闭',
        firstLoginMsg: '首次登录请修改密码',
        confirmPasswordMsg: '确认密码和新密码不一致',
        modifySuccessMsg: '修改成功',
    }
};